module.exports = __webpack_public_path__ + "static/media/default_tutorial_0.56f60395.jpg";